export enum ACTION_TYPE {
  UPDATE = 'UPDATE',
  CREATE = 'CREATE',
}
